import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationCountType {
	totalCount?: number;
}

const initialState: NotificationCountType = {
	totalCount: undefined
};

export const NotificationCountSlice = createSlice({
	name: 'notificationCount',
	initialState,
	reducers: {
		updateNotificationCount: (state, action: PayloadAction<NotificationCountType>) => {
			state = Object.assign(state, action.payload);
		}
	}
});

export default NotificationCountSlice;
